import { memo, useRef } from 'react'

import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import TextWithIconTooltip from 'common-components/TextWithIconTooltip'

import LanguageDropdown from 'containers/SubSidebar/shared/Voices/LanguageDropdown'
import SpeakerDropdown from 'containers/SubSidebar/shared/Voices/SpeakerDropdown'
import SpeakerVelocity from 'containers/SubSidebar/shared/Voices/Velocity'
import BulkTone from 'containers/SubSidebar/shared/Voices/VoiceTone'

import * as Styled from './styled'
import { AdvancedTooltip } from 'common-components'
import { useBulk } from './useBulk'

interface IProps {
  className?: string
}

const TtsBulkActions: React.FC<IProps> = ({ className }: IProps) => {
  const speakerDropdownRef = useRef<HTMLDivElement>(null)
  const {
    isTtsInitialItemsLoading,
    ttsLanguageOptions,
    isLanguageOptionsLoading,
    ttsBulkSpeed,
    ttsBulkLanguageCode,
    ttsBulkSpeakerIdValue,
    isBulkLanguageUndefined,
    initialToneInstruction,
    ttsSpeakers,
    isSpeakersLoading,
    hasSpeakerEmotion,
    onChooseSpeakerOption,
    onChooseLanguageOption,
    onChooseSpeedOption,
    onToneInstructionChange
  } = useBulk()

  return (
    <Styled.TtsBulkActionsWrapper
      className={className}
      $isToneVisible={!!hasSpeakerEmotion}
    >
      <TextWithIconTooltip
        className="icon-with-tooltip"
        title={translate(T.DEFAULT_SPEAKER)}
        tooltipText={translate(T.DEFAULT_SPEAKER_TOOLTIP)}
        gap={4}
        textProps={{
          type: 'subtitle',
          color: 'secondarySemiDark',
          fontWeight: '700'
        }}
        iconProps={{ color: 'secondarySemiLight', customSize: 20 }}
        tooltipPosition="right"
        showMobileTooltip
      />

      <LanguageDropdown
        isDataLoading={isLanguageOptionsLoading || isTtsInitialItemsLoading}
        languageOptions={ttsLanguageOptions}
        selectedLanguageId={ttsBulkLanguageCode}
        onLanguageChange={onChooseLanguageOption}
      />
      <Styled.SpeakerDropdownWrapper
        ref={speakerDropdownRef}
        $isBulkLanguageUndefined={isBulkLanguageUndefined}
      >
        <SpeakerDropdown
          className={'bulk-speaker-dropdown'}
          isDataLoading={isSpeakersLoading || isTtsInitialItemsLoading}
          speakersData={ttsSpeakers}
          selectedSpeakerId={ttsBulkSpeakerIdValue}
          onSpeakerClick={onChooseSpeakerOption}
        />
        {isBulkLanguageUndefined && (
          <AdvancedTooltip
            tooltipText={translate(T.SPEAKER_TOGGLER_TOOLTIP_TEXT)}
            tooltipPosition="top"
            btnRef={speakerDropdownRef}
            isToggledByClick={true}
            showMobileTooltip
          />
        )}
      </Styled.SpeakerDropdownWrapper>

      <SpeakerVelocity
        isBulkMode
        initialValue={ttsBulkSpeed}
        onClick={onChooseSpeedOption}
      />
      <BulkTone
        hasSpeakerEmotion={hasSpeakerEmotion || false}
        initialToneInstruction={initialToneInstruction}
        onToneInstructionChange={onToneInstructionChange}
      />
    </Styled.TtsBulkActionsWrapper>
  )
}

export default memo(TtsBulkActions)
